import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '@/store/state';
import { TippspielState } from './state';

export const getters = {
  tippspielMatches: (state: TippspielState) => state.matches,
  tippspielLeaderboard: (state: TippspielState) => state.leaderboard,
};

const {read} = getStoreAccessors<TippspielState, State>('');

export const readTippspielMatches = read(getters.tippspielMatches);
export const readTippspielLeaderboard = read(getters.tippspielLeaderboard);
